import i18next from 'i18next';
import useStyles from 'style/js-style/components/EAChoiceSeparatorStyle';
import clsx from "clsx";


const EAChoiceSeparator = ({ 
  mode = 'vertical', // vertical | horizontal
  fullSize = false
}) => {
  const { classes } = useStyles();
  return (
    <>
      {/* Séparation */}
      <div className={clsx(classes.separator, classes[mode])}>
        <div className={classes[`separatorLine-${mode}`]} />
        <div>{i18next.t('OR')}</div>
        <div className={classes[`separatorLine-${mode}`]} />
      </div>
    </>
  );
};
export default EAChoiceSeparator;
